var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"px-3"},[_c('v-col',{staticClass:"d-flex primary--text justify-center text-uppercase text-center",attrs:{"cols":"12"}},[_c('strong',{domProps:{"innerHTML":_vm._s(_vm.$gt(_vm.plat).libelle)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }